import React, { Component } from "react";
import Navbar from "../components/Navbar";
import AppLayout from "../Layouts/AppLayout";
import {
    category
} from '../service/FirebaseService/CloundFireStore/model';

export default class View1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: null
    };
  }

  handleGotoCreate = () => {
    this.props.history.push("/categories/create");
  };

  handleInputChange = name => event => {
    this.setState({
      [name]: event.target.value
    });
  };

  handleSuccess = () => {
    alert('create category successfully!');
    this.props.history.push("/categories");
  };

  handleSubmit = async event => {
    event.preventDefault();
    const { title} = this.state;
    const response = await category.create({
        title
    })
    if (response) {
      this.handleSuccess();
    }
  };

  render() {
    return (
      <div>
        <Navbar />
        <AppLayout>
          <div className="card card-default">
            <div className="card-header">Create Category</div>
            <div className="card-body">
              <form onSubmit={this.handleSubmit}>
                <div className="form-group">
                  <label for="title">Title</label>
                  <input
                    onChange={this.handleInputChange("title")}
                    value={this.state.title}
                    type="text"
                    id="title"
                    className="form-control"
                    name="title"
                  />
                </div>
                <div class="form-group">
                  <button type="submit" className="btn btn-success">
                    Add Category
                  </button>
                </div>
              </form>
            </div>
          </div>
        </AppLayout>
      </div>
    );
  }
}
